import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

interface OpacitySliderProps {
  opacity: number; // 0..1
  onChange: (opacity: number) => void;
  onClose: () => void;
}

/**
 * Floating opacity slider rendered over the tooth chart stage when an
 * image overlay is active.
 */
export function OpacitySlider({ opacity, onChange, onClose }: OpacitySliderProps) {
  const { t } = useTranslation();
  const pct = Math.round(opacity * 100);

  return (
    <div className="absolute bottom-4 right-4 z-20 flex items-center gap-3 rounded-xl border border-slate-200 bg-white/95 px-4 py-2.5 shadow-lg backdrop-blur-sm dark:border-slate-700 dark:bg-slate-900/95">
      <span className="text-xs font-medium text-slate-600 dark:text-slate-400">
        {t('dental.imaging.overlay.opacity')}
      </span>
      <input
        type="range"
        min={0}
        max={100}
        value={pct}
        onChange={(e) => onChange(Number(e.target.value) / 100)}
        className="h-1.5 w-28 cursor-pointer accent-indigo-500"
      />
      <span className="w-10 text-right text-xs font-mono text-slate-500 dark:text-slate-400">
        {pct}%
      </span>
      <button
        onClick={onClose}
        title={t('dental.imaging.overlay.hide')}
        className="ml-1 rounded-md p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-600 dark:hover:bg-slate-800 dark:hover:text-slate-200"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
